import { useCallback, useInsertionEffect, useRef } from 'react'

/** Simple implementation of reacts proposed useEvent */
export const useEvent = <T extends Function>(callback: T): T => {
	const ref = useRef(callback)
	useInsertionEffect(() => {
		ref.current = callback
	}, [callback])

	return useCallback<T>(((...args: Array<unknown>) => ref.current(...args)) as unknown as T, [])
}
